import React, { useState } from 'react';

import {
    Card,
    CardHeader,
    CardBody,
    IconButton,
    Button,
    Tooltip,
    ListItem,
    ListItemPrefix,
    Typography,

} from "@material-tailwind/react";
import {
    XMarkIcon,
} from "@heroicons/react/24/outline";



export default function OrderHistoryList(props) {
    const [properties, setOffers] = useState(JSON.parse(props.properties));
    const [history, setHistory] = useState(properties.history || []);


    React.useEffect(() => {
    }, []);


    function cancelClose() {
        props.close();
    }





    return (
        <div className='absolute w-full h-full top-0 left-0 items-center justify-cener m-0  flex place-content-center bg-black/50 '>
            <Card color="white" className="w-full max-w-[48rem] mx-auto rounded-lg max-h-[94vh] overflow-y-auto" >
                <IconButton variant='text' className='top-2 right-2 ml-auto' color="blue-gray" data-refresh={false} onClick={cancelClose}>
                    <XMarkIcon className='w-5 h-5' />
                </IconButton>

                <CardHeader floated={false} shadow={false} className="rounded-none mr-16 mb-0 mt-0 p-0">

                    <div className="mb-6 flex flex-row justify-between gap-4 md:items-center">
                        <div className="flex w-full w-full my-0">
                            <Typography variant="h6" color="blue-gray" className="my-0 p-0">
                                Historia zlecenia
                            </Typography>
                        </div>
                    </div>
                </CardHeader>
                <CardBody className="overflow-auto px-2">
                    <table className="w-full table-auto text-left">
                        <thead>
                            <tr>
                                <th key="data" className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-2">
                                    <div className='flex flex-col items-left'>
                                        <Typography variant="h6" color="blue-gray" className="font-normal opacity-70 md:text-md text-xs">Czas edycji</Typography>
                                    </div>
                                </th>
                                <th key="user" className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-2">
                                    <div className='flex flex-col items-left'>
                                        <Typography variant="h6" color="blue-gray" className="font-normal opacity-70 md:text-md text-xs hidden md:block">Użytkownik</Typography>
                                    </div>
                                </th>
                                <th key="area" className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-2">
                                    <div className='flex flex-col items-left'>
                                        <Typography variant="h6" color="blue-gray" className="font-normal opacity-70 md:text-md text-xs hidden md:block">Wprowadzone zmiany</Typography>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {history && history.map(({ date, user, changes }) => {  
                            return (
                            <tr key={date} className='even:bg-blue-gray-50/50'>
                                <td className="p-2">
                                    <div className="flex items-center gap-1">
                                        <Typography variant="small" color="blue-gray" className="font-normal">
                                            {date}
                                        </Typography>
                                    </div>
                                </td>
                                <td className="p-2">
                                    <Typography variant="small" color="blue-gray" className="font-normal hidden md:block">
                                        {user}
                                    </Typography>
                                </td>
                                <td className="p-2">
                                    <Typography variant="small" color="blue-gray" className="font-normal hidden md:block">
                                        {changes.map((one) => { 
                                            return(<p>{one}</p>)
                                        })
                                        }
                                    </Typography>
                                </td>
                            </tr>
                            )


                             }) }





                        </tbody>
                    </table>
                </CardBody>
            </Card>


        </div>
    );
}

